import React from 'react';
import { useQuery } from '@apollo/client';
import { Badge } from 'anf-core-react';
import { Loading, TmntText } from '../Common';
import { PROFILE_COMPLETION_BADGE_QUERY } from './operations';
import { ProfileCompletionBadgePropTypes, ProfileCompletionBadgeDefaultProps } from './props';

export default function ProfileCompletionBadge({ isLoggedIn }) {
  const { loading, error, data } = useQuery(PROFILE_COMPLETION_BADGE_QUERY, {
    skip: !isLoggedIn,
    ssr: false,
    context: { batch: true },
    fetchPolicy: 'cache-and-network',
  });

  const isProfileComplete = data?.userInfo?.isProfileComplete;
  const hasProfileCompletionEnabled = data?.hasProfileCompletionEnabled;
  const profileCompletionCallToAction = data?.textFor?.profileCompletionCallToAction;

  const shouldShowProfileCompletionBadge = (
    isLoggedIn
    && hasProfileCompletionEnabled
    && !isProfileComplete
  );

  if (error) return null;

  return (
    <Loading isLoading={loading}>
      {
        !shouldShowProfileCompletionBadge
          ? null
          : (
            <Badge>
              <TmntText tmnt={profileCompletionCallToAction} />
            </Badge>
          )
      }
    </Loading>
  );
}

ProfileCompletionBadge.propTypes = ProfileCompletionBadgePropTypes;
ProfileCompletionBadge.defaultProps = ProfileCompletionBadgeDefaultProps;
